import type { PropsWithChildren } from "react";
import React from "react";

import styles from "./Layout.module.css";
import FooterView from "@/components/Footer/FooterView";
import whiteLogo from "@logos/RDEC-WHITE-NOBG-SMALL.png";
import blueLogo from "@logos/RDEC-BLUE-NOBG-SMALL.png";
import HeaderView from "@/components/Header/HeaderView";

const parentMenuData = [
  {
    label: "Home",
    link: "/",
  },
  // {
  //   label: "Produtos e Setores",
  //   children: [
  //     { label: "Automações", link: "/portfolio/automation" },
  //     { label: "Pneumáticos", link: "/portfolio/pneumatics" },
  //   ],
  // },
  // {
  //   label: "Serviços",
  //   link: "/solutions",
  //   children: [
  //     { label: "Consulting", link: "/solutions/consulting" },
  //     { label: "Development", link: "/solutions/development" },
  //   ],
  // },
  {
    label: "Produtos e Soluções",
    link: "/portfolio",
  },
  // {
  //   label: "Sobre nós",
  //   // TODO - link: "/about-us",
  //   // link: "/about-us",
  //   link: "/contact-us",
  // },
  {
    label: "Entre em Contato",
    link: "/contact-us",
  },
];

const MainFrame: React.FC<PropsWithChildren> = ({ children, ...rest }) => {
  return (
    <main className={styles.layout} {...rest}>
      <HeaderView
        headerNormalLogo={blueLogo}
        topbarEnable={true}
        parentMenu={parentMenuData}
      />
      <div className={styles.container}>{children}</div>
      <FooterView footerLogo={whiteLogo} />
    </main>
  );
};

export default MainFrame;
